import { render, staticRenderFns } from "./OCRModelEditor.vue?vue&type=template&id=89d2ce58&scoped=true"
import script from "./OCRModelEditor.vue?vue&type=script&lang=js"
export * from "./OCRModelEditor.vue?vue&type=script&lang=js"
import style0 from "./OCRModelEditor.vue?vue&type=style&index=0&id=89d2ce58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d2ce58",
  null
  
)

export default component.exports